export default __webpack_public_path__ + "static/media/Bajaj4.b263cc53.jpg";